import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c2aa480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pre-trip-complete-day-modal-group-by-date" }
const _hoisted_2 = { class: "text-sm font-semibold" }
const _hoisted_3 = { class: "pre-trip-complete-day-modal-group-by-date__container" }
const _hoisted_4 = { class: "pretrip__information" }
const _hoisted_5 = { class: "pretrip__actions" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.57983 10.9767C6.62125 10.9767 5.84104 10.1966 5.84104 9.23807V5.04492H5.12511C4.50446 5.04492 4 5.54927 4 6.16988V11.6926C4 12.3132 4.50446 12.8177 5.12511 12.8177H10.2391C10.8597 12.8177 11.3642 12.3132 11.3642 11.6926V10.9767H7.57983Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.999 4.12503C12.999 3.5036 12.4954 3 11.874 3H7.57823C6.95676 3 6.45312 3.5036 6.45312 4.12503V9.23864C6.45312 9.86006 6.95676 10.3637 7.57823 10.3637H11.874C12.4954 10.3637 12.999 9.86006 12.999 9.23864V4.12503Z",
    fill: "white"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.05725 8.00004L4.19531 10.862L5.13813 11.8048L8.00005 8.94284L10.862 11.8048L11.8048 10.862L8.94285 8.00004L11.8048 5.13812L10.862 4.19531L8.00005 7.05724L5.13813 4.19531L4.19531 5.13812L7.05725 8.00004Z",
    fill: "#850D16"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.group.date), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.pretrips, (pretrip, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "container__pretrip",
          key: `group-trip-${i}`
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(pretrip.direction.fromCity.name) + " - " + _toDisplayString(pretrip.direction.whereCity.name), 1),
            _createElementVNode("p", null, "Физ.вес: " + _toDisplayString(pretrip.initialTotalWeight) + " кг", 1),
            _createElementVNode("p", null, "Кубатура: " + _toDisplayString(pretrip.initialTotalCubature), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "flex cursor-pointer",
              style: {"background-color":"#0263E0","border-radius":"4px"},
              onClick: ($event: any) => (_ctx.onUpdatePretrip(pretrip))
            }, _hoisted_8, 8, _hoisted_6),
            _hoisted_9
          ])
        ]))
      }), 128))
    ])
  ]))
}